import i18n from 'i18next';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Box, Button, FormHelperText, TextField } from '@material-ui/core';
import useAuth from '../../../hooks/useAuth';
import useMounted from '../../../hooks/useMounted';
import { useNavigate } from 'react-router';

const LoginJWT = (props) => {
  const mounted = useMounted();
  const { login } = useAuth();
  const navigate = useNavigate();

  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
        submit: null
      }}
      validationSchema={Yup
        .object()
        .shape({
          email: Yup
            .string()
            .email('Geçerli bir email adresi giriniz')
            .max(255)
            .required('Email zorunlu'),
          password: Yup
            .string()
            .max(255)
            .required('Şifre zorunlu')
        })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          const response = await login(values.email, values.password);
          if (response.success) {
            if (response.isFirstLogin && !response.permissions.hasOnlyStorager) {
              navigate('/account?tab=profile&edit=true');
            } else if (response.permissions.hasOnlyStorager) {
              navigate('/predemands');
            } else {
              navigate('/deals');
            }
          }
          // if (mounted.current) {
          //   setStatus({ success: true });
          //   setSubmitting(false);
          // }
        } catch (err) {
          console.error(err);
          if (mounted.current) {
            setStatus({ success: false });
            setErrors({ submit: err.message });
            setSubmitting(false);
          }
        }
      }}
    >

      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
        <form
          noValidate
          onSubmit={handleSubmit}
          {...props}
        >

          <TextField
            autoFocus
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            label={i18n.t('LoginJWT.email_adresi')}
            margin="normal"
            name="email"
            onBlur={handleBlur}
            onChange={handleChange}
            type="email"
            value={values.email}
            variant="outlined"
          />

          <TextField
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            label={i18n.t('LoginJWT.\u015Fifre')}
            margin="normal"
            name="password"
            onBlur={handleBlur}
            onChange={handleChange}
            type="password"
            value={values.password}
            variant="outlined"
          />

          {errors.submit
        && (
        <Box sx={{ mt: 3 }}>
          <FormHelperText error>
            {errors.submit}
          </FormHelperText>
        </Box>
        )}
          <Box sx={{ mt: 2 }}>
            <Button
              color="primary"
              disabled={isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              {i18n.t('LoginJWT.giri\u015F')}

            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default LoginJWT;
